<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>수령 수정</h1>
      </div>
    </div>
    <!--  기본 정보  -->
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>기본 정보</h2>
      </div>
      <div class="cmdp_photo">
        <span>
          <img
              v-show="fileSrc !== null"
              :src="fileSrc"
          >
          <img v-show="fileSrc == null" src="@/assets/img/etners-main/aiportal_img.png">
        </span>
          <div class="upload">
            <send-file-upload
                ref="fileUploadRef"
                :button-text="'물품 사진 첨부'"
                @child="getFileData"
                v-bind:file="[]"
            ></send-file-upload>
          </div>
      </div>
      <ul class="filter_list user_photo_right">
        <li>
          <dd>
            <label>No.</label>
            <ul class="w75">
              <li>
                <span class="forg"> 등록 시 자동 생성 </span>
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              진행 상태
              <span class="forg">*</span>
            </label>
            <ul class="w60">
              <div v-for="item in receiveStatusListForSave">
                <input
                    class="k-radio"
                    type="radio"
                    name="statusRef"
                    v-model="receiveInfo.status"
                    :value="item.cdId"
                    :id="`${item.cdId}_status`"
                    @change="onChangeReceiveStatus"
                    :checked="item.cdId === receiveInfo.status "
                >
                <label :for="`${item.cdId}_status`" class="k-radio-label" style="width:100px">{{ item.cdNm }} </label>
              </div>
            </ul>
          </dd>
        </li>
        <li>
         <li>
          <dd>
            <label>
              등록자
            </label>
            <ul>
              <li>
                {{ !!receiveInfo.frstRgstUserNm ? receiveInfo.frstRgstUserNm : receiveInfo.frstRgstId }} &nbsp;|&nbsp; {{ receiveInfo.frstRgstDt }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              상태 여부
              <span class="forg">*</span>
            </label>
            <ul class="w80">
              <li v-if="receiveInfo.status !== '98'">
                <div v-for="item in terrorSignScnList">
                  <input
                      class="k-radio"
                      type="radio"
                      name="terrorSignScn"
                      v-model="receiveInfo.terrorSignScn"
                      :id="`${item.cdId}_terror`"
                      :value="item.cdId"
                      :checked="item.cdId === receiveInfo.terrorSignScn">
                  <label :for="`${item.cdId}_terror`" class="k-radio-label" style="width:60px">{{ item.cdNm }}</label>
                </div>
              </li>
              <li v-if="receiveInfo.status === '98'">
                <div v-for="item in terrorSignScnListForReturn">
                  <input
                      class="k-radio"
                      type="radio"
                      name="terrorSignScn"
                      v-model="receiveInfo.terrorSignScn"
                      :id="`${item.cdId}_terror`"
                      :value="item.cdId"
                      :checked="item.cdId === receiveInfo.terrorSignScn">
                  <label :for="`${item.cdId}_terror`" class="k-radio-label" style="width:60px">{{ item.cdNm }}</label>
                </div>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            &nbsp;
          </dd>
          <dd>
            <label>
              비고
              <span v-show="receiveInfo.terrorSignScn !== '01' || receiveInfo.status === '98'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'contents'}"
                       v-model.trim="receiveInfo.contents"
                       @input="receiveInfo.contents=EtnersCommonUtil.cutByteLength(receiveInfo.contents, 4000)"
                       placeholder="비고를 입력하세요.">
              </li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            &nbsp;
          </dd>
          <dd>
          <label>
            취급 구분/특송사
            <span class="forg">*</span>
          </label>
          <ul class="w50">
            <li class="box_flex">
              <kendo-dropdownlist
                  class="w50"
                  :class="{'error' : errorTarget === 'receiveScn'}"
                  ref="receiveScnRef"
                  v-model="receiveInfo.receiveScn"
                  :data-source="receiveScnList"
                  :data-text-field="'cdNm'"
                  :data-value-field="'cdId'"
                  :style="'width: 50%;'"
                  :height ="1000"
                  @change="onChangeReceiveScn"
              >
              </kendo-dropdownlist>
              <kendo-dropdownlist
                  class="w50 mgl5"
                  :class="{'error' : errorTarget === 'shpcScn'}"
                  ref="shpcScnRef"
                  v-model="receiveInfo.shpcScn"
                  :data-source="shpcScnData"
                  :data-text-field="'cdNm'"
                  :data-value-field="'cdId'"
                  :style="'width: 50%;'"
                  :height ="1000"
                  :disabled="shpScnDisable"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
          </dd>
        </li>
        <li>
           <dd>
            &nbsp;
          </dd>
          <dd>
            <label>
              운송장 번호
              <span class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'blNo'}"
                       v-model.trim="receiveInfo.blNo"
                       @input="receiveInfo.blNo=EtnersCommonUtil.cutByteLength(receiveInfo.blNo, 100)"
                       placeholder="운송장 번호를 입력하세요.">
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>

    <!--  임직원 정보[받는 분]  -->
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>임직원 정보[받는 분]</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>
              사업장 / 거점
              <span v-show="receiveInfo.status!=='98'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <div class="box_flex">
                  <kendo-dropdownlist
                      class="w50"
                      :class="{'error' : errorTarget === 'facility'}"
                      ref="facilityRef"
                      v-model="receiveInfo.facility"
                      :option-label="'사업장을 선택해주세요.'"
                      :data-source="zone1DepthList"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdId'"
                      :disabled="true"
                      @change="receiveInfo.area=null; receiveInfo.course=null; receiveInfo.lockerId=null; onChangeFacility()"
                  >
                  </kendo-dropdownlist>
                  <kendo-dropdownlist
                      class="w50 mgl5"
                      :class="{'error' : errorTarget === 'area'}"
                      ref="areaRef"
                      v-model="receiveInfo.area"
                      :option-label="'사업장 선택 후 선택해주세요'"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdId'"
                      :index="0"
                      :disabled="true"
                      @change="receiveInfo.course=null; receiveInfo.lockerId = null; onChangeArea(); getLockerList();"
                  >
                  </kendo-dropdownlist>
                </div>
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              코스
            </label>
            <ul class="w50">
              <li>
                <kendo-dropdownlist
                    class="w100"
                    ref="courseRef"
                    v-model="receiveInfo.course"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    :data-source="zone3DepthList"
                    :option-label="'거점 선택 후 선택해주세요'"
                >
                </kendo-dropdownlist>
              </li>
            </ul>
          </dd>
        </li>
        <li>
            <dd>
            <label>
              수신 부서
              <span v-show="receiveInfo.status!=='98'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'receiveDept'}"
                       v-model.trim="receiveInfo.receiveDept"
                       @input="receiveInfo.receiveDept=EtnersCommonUtil.cutByteLength(receiveInfo.receiveDept, 500)"
                       placeholder="수신 부서를 입력하세요.">
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              수신
              <span v-show="receiveInfo.status!=='98'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'receiveNm'}"
                       v-model.trim="receiveInfo.receiveNm"
                       @input="receiveInfo.receiveNm=EtnersCommonUtil.cutByteLength(receiveInfo.receiveNm, 100)"
                       placeholder="수신 정보를 입력하세요.">
              </li>
            </ul>
          </dd>
           <dd>
            <label>
              사원 번호
              <span v-show="receiveInfo.status!=='98' && receiveInfo.status!=='97'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'receiveSabun'}"
                       v-model.trim="receiveInfo.receiveSabun"
                       @input="receiveInfo.receiveSabun=EtnersCommonUtil.cutByteLength(receiveInfo.receiveSabun, 20)"
                       placeholder="사원 번호를 입력하세요.">
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              전화 번호
              <span v-show="receiveInfo.status!=='98' && receiveInfo.status!=='97'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       :class="{'error' : errorTarget === 'receiveTel'}"
                       v-model.trim="receiveInfo.receiveTel"
                       @input="receiveInfo.receiveTel=EtnersCommonUtil.cutByteLength(receiveInfo.receiveTel, 20)"
                       placeholder="전화 번호을 입력하세요.">
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              이메일
              <span v-show="receiveInfo.status!=='98' && receiveInfo.status!=='97'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       class="w85"
                       id="receiveEmail"
                       style="display: inline-flex; border-width: 1px;"
                       v-model="nowReceiveEmailAddr"
                       :class="{'error' : errorTarget === 'receiveEmail'}"
                       @input="nowReceiveEmailAddr=EtnersCommonUtil.cutByteLength(nowReceiveEmailAddr, 200)"
                       placeholder="이메일을 입력하세요.">
                <button type="button" class="small_btn orange mgl10 w10" @click="onClickAddMailAddr()">+</button>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              임원 여부
            </label>
            <ul class="w50">
              <li class="w100">
                <input
                    type="checkbox"
                    id="executiveYn"
                    class="k-checkbox"
                    :checked="receiveInfo.executiveYn === 'Y'"
                    @click="receiveInfo.executiveYn = (receiveInfo.executiveYn === 'Y' ? 'N' : 'Y'); onChangeExecutiveYn()"
                >
                <label for="executiveYn" class="k-checkbox-label"><span class="mgl10">임원</span></label>
              </li>
              <li class="forg">임원인 경우 비서 이메일로 메일이 발송됩니다.</li>
            </ul>
          </dd>
          <dd>
            <label>
            </label>
            <ul class="w80">
              <li class="mail_list">
                <span v-for="item in receiveInfo.receiveEmailList">
                  {{ item }}
                  <span class="close mgl10" @click="onClickDeleteMailAddr(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6" style="max-width:12px">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                  </span>
                </span>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              비서 이름
              <span v-if="receiveInfo.executiveYn === 'Y' && receiveInfo.status!=='98'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       v-model.trim="receiveInfo.secretaryNm"
                       :class="{'error' : errorTarget === 'secretaryNm'}"
                       @input="receiveInfo.secretaryNm=EtnersCommonUtil.cutByteLength(receiveInfo.secretaryNm, 50)"
                       placeholder="비서 이름을 입력하세요."
                       :disabled="receiveInfo.executiveYn !== 'Y'">
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              비서 이메일
              <span v-if="receiveInfo.executiveYn === 'Y' && receiveInfo.status!=='98'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       v-model.trim="receiveInfo.secretaryEmail"
                       :class="{'error' : errorTarget === 'secretaryEmail'}"
                       @input="receiveInfo.secretaryEmail=EtnersCommonUtil.cutByteLength(receiveInfo.secretaryEmail, 50)"
                       placeholder="비서 이메일을 입력하세요."
                       :disabled="receiveInfo.executiveYn !== 'Y'">
              </li>
            </ul>
          </dd>
        </li>
      </ul>
      <!--  수령 정보  -->
      <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>수령 정보<div class="forg mgl10">수령 완료 시 정보가 자동 입력됩니다. </div></h2>
      </div>
        <ul class="filter_list">
          <li>
            <dd>
              <label>대리 수령 여부 </label>
              <ul class="w50">
                <li>
                  {{ receiveInfo.steadYn === 'N' ? '본인 수령' : (receiveInfo.steadYn === 'Y' ? '대리 수령' : '-') }}
                </li>
              </ul>
            </dd>
            <dd>
              <label>수령인</label>
              <ul class="w50">
                <li>
                  {{ receiveInfo.steadYn ? (receiveInfo.steadYn === 'N' ? receiveInfo.receiveNm : receiveInfo.steadNm) : '-' }}
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>용도</label>
              <ul class="w50">
                <li>
                  {{ !!receiveInfo.ppsScnNm ? receiveInfo.ppsScnNm : '-' }}
                </li>
              </ul>
            </dd>
            <dd>
              <label>수령인 부서</label>
              <ul class="w50">
                <li>
                  {{ receiveInfo.steadYn === 'N' ? receiveInfo.receiveDept : (receiveInfo.steadYn === 'Y' ? receiveInfo.steadDept : '-') }}
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>반입 목적</label>
              <ul class="w50">
                <li>
                  {{ !!receiveInfo.receiPurposeNm ? receiveInfo.receiPurposeNm : '-' }}
                  <a v-show="receiveInfo.receiPurpose === '03'"> {{ ' / ' + receiveInfo.receiPurposeDesc }} </a>
                </li>
              </ul>
            </dd>
            <dd>
              <label>수령 일시</label>
              <ul class="w50">
                <li>
                  {{ !!receiveInfo.receiveDt ? receiveInfo.receiveDt : '-' }}
                </li>
              </ul>
            </dd>
          </li>
        </ul>
    </div>
    </div>
    <!--  상세 정보-->
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>상세 정보</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>
              발신
              <span v-show="receiveInfo.status!=='98'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input type="text"
                       v-model.trim="receiveInfo.sendNm"
                       :class="{'error' : errorTarget === 'sendNm'}"
                       @input="receiveInfo.sendNm=EtnersCommonUtil.cutByteLength(receiveInfo.sendNm, 100)"
                       placeholder="발신 정보를 입력하세요.">
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              수량
              <span class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <input
                    class="w100"
                    :class="{'error' : errorTarget === 'qty'}"
                    type="number"
                    min="0"
                    ref="qtyRef"
                    v-model="receiveInfo.qty"
                    @input="receiveInfo.qty = receiveInfo.qty.slice(0, 2)"
                    :placeholder="'수량을 입력하세요'">
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              수신 회사
            </label>
            <ul class="w50">
              <li>
                <kendo-dropdownlist
                    class="w100"
                    :class="{'error' : errorTarget === 'receiveAreaScn'}"
                    ref="receiveAreaScnRef"
                    v-model.trim="receiveInfo.receiveAreaScn"
                    maxlength="50"
                    :data-source="receiveAreaScnList"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    :option-label="'선택'"
                    :index="0"
                    :enable="false"
                >
                </kendo-dropdownlist>
              </li>
            </ul>
          </dd>
          <dd>
            <label>
              구분
              <span v-show="receiveInfo.status!=='98'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <div v-for="item in receiveEtcScnList">
                  <input
                      class="k-radio"
                      type="radio"
                      name="etcScn"
                      v-model="receiveInfo.etcScn"
                      :id="`${item.cdId}_etc`"
                      :value="item.cdId"
                      @change="receiveInfo.etcScn = item.cdId"
                      :checked="receiveInfo.etcScn === item.cdId">
                  <label :for="`${item.cdId}_etc`" class="k-radio-label" style="width:100px">{{ item.cdNm }}</label>
                </div>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>
              보관 위치
              <span v-show="receiveInfo.status!=='98'" class="forg">*</span>
            </label>
            <ul class="w50">
              <li>
                <kendo-dropdownlist
                    class="w100"
                    :class="{'error' : errorTarget === 'lockerId'}"
                    ref="lockerIdRef"
                    v-model="receiveInfo.lockerId"
                    :data-source="lockerList"
                    :data-text-field="'lockerNm'"
                    :data-value-field="'lockerId'"
                    :style="'width: 50%;'"
                    :disabled="!!receiveInfo.lockerCellId"
                >
                </kendo-dropdownlist>
              </li>
            </ul>
          </dd>
        </li>
        <li>

          <dd>
            <label>
              무인보관함 번호
            </label>
            <ul class="w80">
              <ul v-if="!!receiveInfo.lockerCellId" >
                <li>
                  {{ receiveInfo.lockerCellId }}
                </li>
                <span class="forg"> 보관함 이동은 키오스크에서 가능합니다. </span>
              </ul>
              <ul v-else-if="isLockerYn" class="w70">
                <li>
                  <span class="forg"> 문서실 보관중 </span>
                </li>
              </ul>
              <ul v-else class="w70">
                <li>
                  <span class="forg"> 수령 물품 등록 시 지정 </span>
                </li>
              </ul>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <!--  버튼 영역  -->
    <div class="button_area w30">
      <ul>
        <li class="w25">
          <button type="button" class="large_btn" @click="redirectToList">목록</button>
        </li>
        <li class="w25">
          <button type="submit" class="large_btn orange" @click="onClickUpdate">저장</button>
        </li>
        <li class="w25">
          <button type="submit" class="large_btn orange" v-show="receiveInfo.status !== '98' && receiveInfo.status !== '97'" :disabled="!isLockerYn" @click="onClickUpdateAndMail">저장 후 메일발송</button>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import EtnersParseUtil from "@/common/etners.parse.util";
import EtnersDatetimeUtil from "@/common/etners.datetime.util";
import EtnersCommonUtil from "@/common/etners.common.util";
import CreateSteadReceive from "@/components/receive/CreateSteadReceive.vue";
import SendFileUpload from "@/components/send/SendFileUpload.vue";
import $ from "jquery";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import EtnersLogisticsUtil from '@/common/etners.logistics.util'

export default {
  name: "ReceiveUpdate",
  components: {CreateSteadReceive, SendFileUpload},
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted() {
    const vm = this
    const refs = vm.$refs
    vm.getReceiveInfo().then(() => {
      vm.availableUpdateCheck()
      vm.onChangeFacility()
      vm.onChangeArea()
      vm.getLockerList()
      vm.onChangeReceiveScn()
    })

    // 메일 추가 엔터키 세팅
    const element = document.getElementById('receiveEmail');
    if (element !== undefined) {
      element.onkeyup = function (e) {
        const currentKeyCode = e.code
        if (currentKeyCode === 'Enter' || currentKeyCode === 'NumpadEnter') {
          vm.onClickAddMailAddr();
        }
      }
    }

  },
  computed: {
    isLockerYn(){
      // receiveInfo.lockerId와 lockerList를 사용하여 lockerYn이 'N'인지 확인합니다.
      // 선택한 lcokeId가 문서실인지를 확인
      const selectedLocker = this.lockerList.find(
        (locker) => locker.lockerId === this.receiveInfo.lockerId
      );
      return selectedLocker && selectedLocker.storageType === "02";
    },
  },
  methods: {
    // 수령 물품 정보
    getReceiveInfo() {
      const vm = this
      const refs = vm.$refs
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveDetail.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        receiveId: vm.receiveId
      }
      return new Promise((resolve, reject) => {
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('정상적으로 처리되지 않았습니다.')
            return false
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            if (response.data.resultStatus.messageCode === '4002') {
              kendo.alert(response.data.resultStatus.messageText)
              vm.$router.go(-1)
            } else {
              kendo.alert(response.data.resultStatus.messageText)
              return false
            }
          }
          let resultData = response.data.resultData
          vm.receiveInfo = resultData
          if (resultData.fileInfo !== null) {
            vm.fileSrc = `${ApiConfig.eklDomain}/files/2000/${resultData.fileInfo.fileId}/0?lutk=${vm.loginUserToken}`
          }
          if (vm.receiveInfo.area === "0101" || vm.receiveInfo.area === "0102") {
            const areaRef = refs.areaRef
            const receiveAreaScn = refs.receiveAreaScnRef
            if (areaRef !== undefined && areaRef !== null) {
              const area = areaRef.kendoWidget().value()
              receiveAreaScn.kendoWidget().enable(area === "0101" || area === "0102")
            }
          }
          vm.changeReceiveScnFlag = true
          if (vm.receiveInfo.terrorSignScn !== "01") {
            vm.terrorFlag = true
          }
          if (vm.receiveInfo.area === "01" || vm.receiveInfo.area === "02") {
            vm.changeReceiveAreaScnFlag = true
          }
          resolve(true)
        })
      })
    },
    // 수정 유효성 체크 '접수신청', '완료'상태 수정 불가
    availableUpdateCheck() {
      const vm = this
      if(vm.receiveInfo.status === '02' || vm.receiveInfo.status === '99'){
        kendo.alert("수정 불가능한 데이터 입니다.")
        vm.$router.go(-1)
      }
      return true
    },
    // 거점별 무인보관함 리스트
    getLockerList () {
      const vm = this
      const area = vm.$refs.areaRef.kendoWidget().value()
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/lockerNmList.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        area: area,
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.lockerList = resultData
        vm.$refs.lockerIdRef.kendoWidget().setDataSource(vm.lockerList)
        vm.$refs.lockerIdRef.kendoWidget().value(vm.receiveInfo.lockerId)
      })
    },
    // 이미지 파일 미리 보기 세팅
    getFileData(fileInfo) {
      const vm = this
      vm.receiveInfo.imgFile = fileInfo
      // 미리보기 세팅
      setTimeout(() => {
        const raw = fileInfo[0].rawFile
        const reader = new FileReader()
        const name = fileInfo[0].name
        if (raw) {
          reader.onloadend = function () {
            vm.fileSrc = this.result
          }
          reader.readAsDataURL(raw)
        }
      })
    },
    // 취급 구분에 따른 특송사 선택
    onChangeReceiveScn() {
      const vm = this
      const refs = vm.$refs
      const receiveScnRef = refs.receiveScnRef
      if (receiveScnRef !== undefined && receiveScnRef !== null) {
        const receiveScn = receiveScnRef.kendoWidget().value()
        if (receiveScn !== "01") {
          vm.changeReceiveScnFlag = true
        } else {
          vm.changeReceiveScnFlag = false
        }
        if (receiveScn === "01" || receiveScn === "02" || receiveScn === "03" || receiveScn === "04" || receiveScn === "05" || receiveScn === "06" || receiveScn === "07") {
          vm.shpcScnData = vm.shpcScnData2.filter((shpcScn) => {
            if (shpcScn.cdId === '08') {
              return shpcScn
            }
          })
          refs.shpcScnRef.kendoWidget().setDataSource(vm.shpcScnData)
          refs.shpcScnRef.kendoWidget().value('08')
          vm.receiveInfo.shpcScn = '08'
          vm.shpScnDisable = true
        }
        if (receiveScn === "08") {
          vm.shpcScnData = vm.shpcScnData2.filter((shpcScn) => {
            if (shpcScn.cdId === '09') {
              return shpcScn
            }
          })
          refs.shpcScnRef.kendoWidget().setDataSource(vm.shpcScnData)
          refs.shpcScnRef.kendoWidget().value('09')
          vm.receiveInfo.shpcScn = '09'
          vm.shpScnDisable = true
        }
        if (receiveScn === "09") {
          vm.shpcScnData = vm.shpcScnData2.filter((shpcScn) => {
            if (shpcScn.cdId === '01' || shpcScn.cdId === '02' || shpcScn.cdId === '03' || shpcScn.cdId === '04' || shpcScn.cdId === '05' || shpcScn.cdId === '06' || shpcScn.cdId === '07') {
              return shpcScn
            }
          })
          refs.shpcScnRef.kendoWidget().setDataSource(vm.shpcScnData)
          refs.shpcScnRef.kendoWidget().value('01')
          vm.receiveInfo.shpcScn = '01'
          vm.shpScnDisable = false
        }
      }
    },
    //수정 버튼
    async onClickUpdate () {
      const vm = this
      if (vm.validation()) {
        await kendo.confirm('수정 하시겠습니까?').done(
          async function () {
            vm.updateReceive(false)
          })
      }
    },
    // 메일 발송 및 수정 버튼
    async onClickUpdateAndMail () {
      const vm = this
      if (vm.validation()) {
        await kendo.confirm('메일 발송과 수정 하시겠습니까?').done(
          async function () {
            vm.updateReceive(true)
          })
      }
    },
    // 예외처리 메서드
    validation() {
      const vm = this
      const receiveInfo = vm.receiveInfo

      if (EtnersCommonUtil.isEmpty(receiveInfo.status)) {
        kendo.alert('진행 상태를 선택해 주세요')
        vm.errorTarget = null
        return
      }
      if (vm.receiveInfo.status === '01' ) {
        if (EtnersCommonUtil.isEmpty(receiveInfo.terrorSignScn)) {
          kendo.alert('상태여부를 선택해 주세요')
          vm.errorTarget = null
          return
        }
        if (receiveInfo.terrorSignScn !== '01' && EtnersCommonUtil.isEmpty(receiveInfo.contents)) {
          kendo.alert('비고를 입력해 주세요')
          vm.errorTarget = 'contents'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveScn)) {
          kendo.alert('취급 구분을 선택 해주세요')
          vm.errorTarget = 'receiveScn'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.shpcScn)) {
          kendo.alert('특송사를 선택 해주세요')
          vm.errorTarget = 'shpcScn'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.blNo)){
          kendo.alert('운송장 번호를 입력해주세요.')
          vm.errorTarget = 'blNo'
          return
        } else if (!EtnersCommonUtil.isBlNo(receiveInfo.blNo)) {
          kendo.alert('운송장 번호는 영어와 숫자만 입력해주세요.')
          vm.errorTarget = 'blNo'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.facility)) {
          kendo.alert('사업장을 선택 해주세요')
          vm.errorTarget = 'facility'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.area)) {
          kendo.alert('거점을 선택해 주세요')
          vm.errorTarget = 'area'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveDept)) {
          kendo.alert('수신부서를 입력해 주세요')
          vm.errorTarget = 'receiveDept'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveNm)) {
          kendo.alert('수신 정보를 입력해 주세요')
          vm.errorTarget = 'receiveNm'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveSabun)) {
          kendo.alert('사원 번호를 입력해 주세요')
          vm.errorTarget = 'receiveSabun'
          return
        } else if (!EtnersLogisticsUtil.isValidSabun(receiveInfo.receiveSabun)){
          kendo.alert('사원 번호를 형식에 맞게 입력해 주세요')
          vm.errorTarget = 'receiveSabun'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveTel)) {
          kendo.alert('전화 번호를 입력해 주세요')
          vm.errorTarget = 'receiveTel'
          return
        } else if (!EtnersLogisticsUtil.isTelNum(receiveInfo.receiveTel)) {
          kendo.alert('전화 번호를 형식에 맞게 입력해 주세요.')
          vm.errorTarget = 'receiveTel'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveEmailList)) {
          kendo.alert('이메일을 입력해 주세요.')
          vm.errorTarget = 'receiveEmail'
          return
        }
        if (receiveInfo.executiveYn === 'Y') {
          if (EtnersCommonUtil.isEmpty(receiveInfo.secretaryNm)) {
            kendo.alert('비서 이름을 입력해 주세요')
            vm.errorTarget = 'secretaryNm'
            return
          }
          if (EtnersCommonUtil.isEmpty(receiveInfo.secretaryEmail)){
            kendo.alert('비서 이메일을 입력해 주세요.')
            vm.errorTarget = 'secretaryEmail'
            return
          } else if (!EtnersLogisticsUtil.isEmailDomainAllowed(receiveInfo.secretaryEmail)) {
            kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg("비서"))
            vm.errorTarget = 'secretaryEmail'
            return
          }
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.sendNm)) {
          kendo.alert('발신 정보를 입력해 주세요')
          vm.errorTarget = 'sendNm'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.qty) || !EtnersCommonUtil.isPositiveInteger(receiveInfo.qty)) {
          kendo.alert('수량은 1이상의 숫자를 입력해주세요')
          vm.errorTarget = 'qty'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.etcScn)) {
          kendo.alert('구분을 선택해 주세요')
          vm.errorTarget = null
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.lockerId)) {
          kendo.alert('보관 위치를 선택해 주세요')
          vm.errorTarget = 'lockerId'
          return
        }
      }
      if (vm.receiveInfo.status === '97' ) {
        if (EtnersCommonUtil.isEmpty(receiveInfo.terrorSignScn)) {
          kendo.alert('상태여부를 선택해 주세요')
          vm.errorTarget = null
          return
        }
        if (receiveInfo.terrorSignScn !== '01' && EtnersCommonUtil.isEmpty(receiveInfo.contents)) {
          kendo.alert('비고를 입력해 주세요')
          vm.errorTarget = 'contents'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveScn)) {
          kendo.alert('취급 구분을 선택 해주세요')
          vm.errorTarget = 'receiveScn'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.shpcScn)) {
          kendo.alert('특송사를 선택 해주세요')
          vm.errorTarget = 'shpcScn'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.blNo)){
          kendo.alert('운송장 번호를 입력해주세요.')
          vm.errorTarget = 'blNo'
          return
        } else if (!EtnersCommonUtil.isBlNo(receiveInfo.blNo)) {
          kendo.alert('운송장 번호는 영어와 숫자만 입력해주세요.')
          vm.errorTarget = 'blNo'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.facility)) {
          kendo.alert('사업장을 선택 해주세요')
          vm.errorTarget = 'facility'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.area)) {
          kendo.alert('거점을 선택해 주세요')
          vm.errorTarget = 'area'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveDept)) {
          kendo.alert('수신부서를 입력해 주세요')
          vm.errorTarget = 'receiveDept'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveNm)) {
          kendo.alert('수신 정보를 입력해 주세요')
          vm.errorTarget = 'receiveNm'
          return
        }
        if (EtnersCommonUtil.isNotEmpty(receiveInfo.receiveSabun) && !EtnersLogisticsUtil.isValidSabun(receiveInfo.receiveSabun)){
          kendo.alert('사원 번호를 형식에 맞게 입력해 주세요')
          vm.errorTarget = 'receiveSabun'
          return
        }
        if (EtnersCommonUtil.isNotEmpty(receiveInfo.receiveTel) && !EtnersLogisticsUtil.isTelNum(receiveInfo.receiveTel)) {
          kendo.alert('전화 번호를 형식에 맞게 입력해 주세요.')
          vm.errorTarget = 'receiveTel'
          return
        }
        if (receiveInfo.executiveYn === 'Y') {
          if (EtnersCommonUtil.isEmpty(receiveInfo.secretaryNm)) {
            kendo.alert('비서 이름을 입력해 주세요')
            vm.errorTarget = 'secretaryNm'
            return
          }
          if (EtnersCommonUtil.isEmpty(receiveInfo.secretaryEmail)){
            kendo.alert('비서 이메일을 입력해 주세요.')
            vm.errorTarget = 'secretaryEmail'
            return
          } else if (!EtnersLogisticsUtil.isEmailDomainAllowed(receiveInfo.secretaryEmail)) {
            kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg("비서"))
            vm.errorTarget = 'secretaryEmail'
            return
          }
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.sendNm)) {
          kendo.alert('발신 정보를 입력해 주세요')
          vm.errorTarget = 'sendNm'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.qty) || !EtnersCommonUtil.isPositiveInteger(receiveInfo.qty)) {
          kendo.alert('수량은 1이상의 숫자를 입력해주세요')
          vm.errorTarget = 'qty'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.etcScn)) {
          kendo.alert('구분을 선택해 주세요')
          vm.errorTarget = null
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.lockerId)) {
          kendo.alert('보관 위치를 선택해 주세요')
          vm.errorTarget = 'lockerId'
          return
        }
        if (!vm.isLockerYn){
          kendo.alert('직접 전달건은 문서실 보관만 가능합니다')
          vm.errorTarget = 'lockerId'
          return
        }
      }
      if (vm.receiveInfo.status === '98' ) {
        if (EtnersCommonUtil.isEmpty(receiveInfo.terrorSignScn)) {
          kendo.alert('상태여부를 선택해 주세요')
          vm.errorTarget = null
          return
        }
        if (receiveInfo.terrorSignScn === "01" ) {
          kendo.alert('반송시 상태 여부를 무로 지정할 수 없습니다.')
          vm.errorTarget = null
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.contents)) {
          kendo.alert('비고를 입력해 주세요')
          vm.errorTarget = 'contents'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.receiveScn)) {
          kendo.alert('취급 구분을 선택 해주세요')
          vm.errorTarget = 'receiveScn'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.shpcScn)) {
          kendo.alert('특송사를 선택 해주세요')
          vm.errorTarget = 'shpcScn'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.blNo)){
          kendo.alert('운송장 번호를 입력해주세요.')
          vm.errorTarget = 'blNo'
          return
        } else if (!EtnersCommonUtil.isBlNo(receiveInfo.blNo)) {
          kendo.alert('운송장 번호는 영어와 숫자만 입력해주세요.')
          vm.errorTarget = 'blNo'
          return
        }
        if (EtnersCommonUtil.isNotEmpty(receiveInfo.receiveSabun) && !EtnersLogisticsUtil.isValidSabun(receiveInfo.receiveSabun)){
          kendo.alert('사원 번호를 형식에 맞게 입력해 주세요')
          vm.errorTarget = 'receiveSabun'
          return
        }
        if (EtnersCommonUtil.isNotEmpty(receiveInfo.receiveTel) && !EtnersLogisticsUtil.isTelNum(receiveInfo.receiveTel)) {
          kendo.alert('전화 번호를 형식에 맞게 입력해 주세요.')
          vm.errorTarget = 'receiveTel'
          return
        }
        if (EtnersCommonUtil.isNotEmpty(receiveInfo.secretaryEmail) && !EtnersLogisticsUtil.isEmailDomainAllowed(receiveInfo.secretaryEmail)) {
          kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg("비서"))
          vm.errorTarget = 'secretaryEmail'
          return
        }
        if (EtnersCommonUtil.isEmpty(receiveInfo.qty) || !EtnersCommonUtil.isPositiveInteger(receiveInfo.qty)) {
          kendo.alert('수량은 1이상의 숫자를 입력해주세요')
          vm.errorTarget = 'qty'
          return
        }
        if(!(vm.isLockerYn || EtnersCommonUtil.isEmpty(receiveInfo.lockerId))){
          kendo.alert('물품 보관위치가 문서실이거나 지정되지 않은 경우에만 반송처리가 가능합니다.')
          vm.errorTarget = 'lockerId'
          return
        }
      }
      
      vm.errorTarget = null
      return true
    },
    // 수정 메서드
    updateReceive(isSendMail) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveUpdate.json`
      const formData = new FormData()
      const params = {
        loginUserToken: vm.loginUserToken,
        receiveInfo : vm.receiveInfo,
        isSendMail: isSendMail,
      }
      if (vm.receiveInfo.imgFile) {
        vm.receiveInfo.imgFile.forEach(function (v) {
          formData.append('file', v.rawFile)
        })
      }
      formData.append('receiveUpdateRequestParam', new Blob([JSON.stringify(params)], {
        type: 'application/json',
      }))
      ApiUtil.postIncludeUploadFile(url, formData).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        kendo.alert('수정되었습니다.')
        vm.$router.push({
          name: 'ReceiveDetail',
          params: {
            receiveId: vm.receiveId
          }
        })
      })
    },
    // 목록 이동 메서드
    redirectToList() {
      this.$router.push({
        name: "ReceiveList"
      })
    },
    // facility 에 따른 area 세팅
    onChangeFacility() {
      const vm = this
      vm.onChange1Depth('facilityRef')
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
      vm.$refs.areaRef.kendoWidget().value(vm.receiveInfo.area)
      vm.$refs.courseRef.kendoWidget().setDataSource('')
      vm.$refs.lockerIdRef.kendoWidget().setDataSource('')
    },
    // area 에 따른 course 세팅
    onChangeArea() {
      const vm = this
      vm.onChange2Depth('areaRef')
      vm.$refs.courseRef.kendoWidget().setDataSource(vm.zone3DepthList)
      vm.$refs.courseRef.kendoWidget().value(vm.receiveInfo.course)
    },
    // 반송시 상태여부 초기화
    onChangeReceiveStatus () {
      const vm = this
      // 반송시 상태여부 초기화
      if(vm.receiveInfo.status === '98'){
        vm.receiveInfo.terrorSignScn = null
      }
      // 수령 등록 상태의 경우, 상태여부 '무' 초기값 지정
      else {
        vm.receiveInfo.terrorSignScn = '01'
      }
    },
    // 메일 리스트 추가
    onClickAddMailAddr(){
      const vm = this
      const emailAddr = vm.nowReceiveEmailAddr
      if (EtnersCommonUtil.isEmpty(emailAddr)){
        kendo.alert('이메일을 입력해 주세요.')
        vm.errorTarget = 'receiveEmail'
        return
      }
      /// 메일 유효성검사, 이미 추가된 이메일인지 체크
      else if(vm.receiveInfo.receiveEmailList.length >= 5){
        kendo.alert('메일발송은 최대 5명까지 가능합니다.')
        vm.errorTarget = 'receiveEmail'
        return
      }
      else if (!EtnersLogisticsUtil.isEmailDomainAllowed(emailAddr)) {
        kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg("수신인"))
        vm.errorTarget = 'receiveEmail'
        return
      }
      else if (vm.receiveInfo.receiveEmailList.includes(emailAddr)){
        kendo.alert('이미 추가된 이메일 입니다.')
        vm.errorTarget = 'receiveEmail'
        return
      }
      vm.errorTarget = null
      // 리스트에 추가 후 초기화
      vm.receiveInfo.receiveEmailList.push(emailAddr)
      vm.nowReceiveEmailAddr = ''
    },
    // 메일 리스트 삭제
    onClickDeleteMailAddr(emailAddr){
      const vm = this
      vm.receiveInfo.receiveEmailList = vm.receiveInfo.receiveEmailList.filter(item => (item !== emailAddr))
    },
    // 임원여부 N인 경우 비서 정보 초기화
    onChangeExecutiveYn () {
      const vm = this
      if (vm.receiveInfo.executiveYn !== 'Y') {
        // 비서 정보 초기화
        vm.receiveInfo.secretaryNm = null
        vm.receiveInfo.secretaryEmail = null
      }
    },
  },
  data: function () {
    const vm = this
    loginUserData: sessionStorage.getItem('loginUserData')
    const now = EtnersParseUtil.convertYYYYMMDDHHMIFormat(EtnersDatetimeUtil.dateToYYYYMMDDHHMI(new Date()))

    const logisticsCd = this.$store.state.codeRequestStore.search.combobox.logisticsCd.data

    let shpcScnList = []
    for (let item of logisticsCd) {
      if (item.cdGrup === '12') {
        shpcScnList.push(item)
      }
    }

    return {
      EtnersCommonUtil: EtnersCommonUtil,
      fileSrc: null,
      shpcScnData: shpcScnList,
      shpcScnData2: shpcScnList,
      etcScn: null,
      receiveScn: null,
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      receiveId: this.$route.params.receiveId,
      receiveInfo: {},
      changeReceiveScnFlag: false,
      receiveEmail: null,
      receiveTel: null,
      receiveSabun: null,
      changeReceiveAreaScnFlag: false,
      shpScnDisable: true,
      terrorFlag: false,
      errorTarget: null,
      lockerList: [],
      nowReceiveEmailAddr: '',
    }
  }

}
</script>
